import store from '@/store'
import actions from '@/store/actions'

import mutations from '../store/mutations'
import { getMultipleUsers, getUser } from './graphService'

export const getAllDictionariesForAdminPanel = async () => {
  const data = await store.dispatch(actions.callApi, { url: 'dictionaries' })
  const projects = await Promise.all(data.projects.map(async project => {
    const users = await getMultipleUsers(project.users.map(i => i.mailNickname))
    return { ...project, users: project.users.map(user => ({ ...user, ...users.find(i => i.mailNickname === user.mailNickname) })) }
  }))
  const userAccess = await Promise.all(data.userAccess.map(async access => {
    return {
      ...access,
      user: await getUser(access.mailNickname),
      project: access.resourceKey === 'projectId' ? data.projects.find(i => i.id === access.resourceId) : {}
    }
  }))
  return {
    ...data,
    projects,
    userAccess
  }
}

export const getAllDictionariesForInsights = async () => {
  const data = await store.dispatch(actions.callApi, { url: 'dictionaries/insights' })
  return data
}

export const saveStepName = async (data) => {
  await store.dispatch(actions.callApi, {
    url: data.id ? `dictionaries/workflowSteps/${data.id}` : 'dictionaries/workflowSteps',
    method: data.id ? 'PUT' : 'POST',
    body: {
      name: data
    }
  })
  store.dispatch(actions.createMessage, { text: 'Step name was added', color: 'success' })
}

export const saveDictionaryItem = async (route, data) => {
  const item = await store.dispatch(
    actions.callApi,
    {
      url: data.id ? `dictionaries/${route}/${data.id}` : `dictionaries/${route}`,
      method: data.id ? 'PUT' : 'POST',
      body: {
        ...data,
        createdAt: undefined,
        updatedAt: undefined
      }
    }
  )
  store.dispatch(actions.createMessage, { text: data.id ? 'Item updated' : 'Item added', color: 'success' })
  return item
}

export const saveCause = async (data) => {
  const cause = await store.dispatch(
    actions.callApi,
    {
      url: data.id ? `dictionaries/category/${data.id}` : 'dictionaries/category',
      method: data.id ? 'PUT' : 'POST',
      body: {
        name: data.name,
        area: data.area,
        id: data.id
      }
    }
  )
  store.dispatch(actions.createMessage, { text: 'Category added', color: 'success' })
  return cause
}

export const deleteDictionaryItem = async (route, id) => {
  const category = await store.dispatch(
    actions.callApi,
    {
      url: `dictionaries/${route}/${id}`,
      method: 'DELETE'
    }
  )
  store.dispatch(actions.createMessage, { text: 'Item deleted', color: 'success' })
  return category
}

export const getRisks = async () => {
  const data = await store.dispatch(actions.callApi, { url: 'dictionaries/risks' })
  await store.commit(mutations.SET_RISKS, data)
}
